/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'transaction': {
    width: 24,
    height: 20,
    viewBox: '0 0 24 20',
    data: '<path pid="0" d="M23.887 11.725L16.23 20l-1.033-.956 5.471-5.912H0v-1.407h23.887zM7.657 0L8.69.956 3.219 6.868h20.668v1.407H0L7.657 0z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/transaction.js